import { Link } from '@tanstack/react-router'
import { Eye } from 'lucide-react'

// Amber matches the internal-note treatment: staff must never mistake the lens
// for their own view.
export function ViewingAsBanner({ name, companyName }: { name: string; companyName: string }) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100">
      <span className="flex items-center gap-2">
        <Eye className="h-4 w-4" />
        Viewing as <strong>{name}</strong> · {companyName}
      </span>
      <Link to="/admin/view-as" search={{} as never} className="font-medium underline">
        Exit
      </Link>
    </div>
  )
}
